import StorageService from "@/services/api/storage"
const storageService = new StorageService();

const state = {
  exceedAlertThreshold: false,
  summary: {},
}

const getters = {}

const mutations = {
  setExceedAlertThreshold(state, item) {
    state.exceedAlertThreshold = item
  },

  setSummary(state, payload) {
    state.summary = payload;
  }
}

const actions = {
  async fetchStorageSummary({ commit, state }, force = false) {
    if (!force && Object.keys(state.summary).length) return

    try {
      const { data } = await storageService.getStorageSummaryByType();
      commit("setSummary", data);
    } catch (error) {
      commit("setSummary", {});
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
